import { z } from 'zod'

// channel names can only contain lowercase letters, numbers, hyphens, and underscores, and must be 80 characters or less.
const isChannelNameValid = (channelName: string) => {
  if (channelName.length === 0) return true
  const CHANNEL_NAME_REGEX = new RegExp(/^([A-Za-z0-9\-_]+)$/, 'g')
  return channelName.length < 80 && !!channelName.match(CHANNEL_NAME_REGEX)
}
export const EditSiteSchema = z.object({
  siteName: z
    .string({ message: 'Site name is required' })
    .min(1)
    .max(68, { message: 'Site name must be less than 68 characters' }),
  salesforceAccount: z.string().optional(),
  siteSlackChannel: z.string().refine((data) => isChannelNameValid(data), {
    message: 'Channel name contains invalid characters',
  }),
  sitePrimaryAddress: z.string(),
  siteSecondaryAddress: z.string(),
  siteCity: z.string(),
  siteRegion: z.string(),
  siteCountry: z.string(),
  sitePostalCode: z
    .string()
    .max(11, { message: 'Postal code must be less than 11 characters' }),
})

export type EditSiteSchema = z.infer<typeof EditSiteSchema>

export const defaultValues: EditSiteSchema = {
  siteName: '',
  siteSlackChannel: '',
  sitePrimaryAddress: '',
  siteSecondaryAddress: '',
  siteCity: '',
  siteRegion: '',
  sitePostalCode: '',
  siteCountry: '',
}
